import React from 'react'
import { Modal } from "@mui/material"
import Button from "../Button/Button"
import SuccessIcon from "../../assets/images/icons/SuccessSnackbarIcon.svg"

const ContractSignedModal = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      closeAfterTransition
      onClose={onClose}
    >
      <div className="flex items-center justify-center h-screen">
        <div className="bg-paper rounded-2xl p-6 flex flex-col items-center max-w-[400px]">
          <img src={SuccessIcon} alt="Success" className="w-16 h-16 mb-4" />
          <h4 className="font-sans text-lg-18 text-text-primary mb-2 text-center">
            Contract Signed Successfully
          </h4>
          <p className="text-text-secondary text-center mb-6">
            The customer has successfully signed the Legal Services Agreement.
          </p>
          <Button onClick={onClose} width="w-[120px]">
            Got it
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default ContractSignedModal
